import { z } from "zod";
/**
 * Перечисления раздела «Корпоративные клиенты» (контракт v2.0, identifiers.md §8).
 * Статус компании — `zCorpCompanyStatus` из `types/corp/corpSession.common.ts` (FR-005).
 */
export const zCreditState = z.enum(["OK", "LIMIT_EXHAUSTED"]);
export const CREDIT_STATE_LABELS = {
    OK: "Лимит в норме",
    LIMIT_EXHAUSTED: "Лимит исчерпан",
};
export const CREDIT_STATE_COLORS = {
    OK: "green",
    LIMIT_EXHAUSTED: "red",
};
export const CORP_COMPANY_STATUS_COLORS = {
    ACTIVE: "green",
    SUSPENDED: "orange",
    ARCHIVED: "default",
};
export const zBillingPeriod = z.enum(["MONTH", "QUARTER"]);
export const BILLING_PERIOD_LABELS = {
    MONTH: "Месяц",
    QUARTER: "Квартал",
};
/** Состояние привязки: вычисляет БД (§2.5, CCR-009), клиент только отображает. */
export const zCorpLinkState = z.enum(["SCHEDULED", "ACTIVE", "EXPIRED", "BLOCKED"]);
export const CORP_LINK_STATE_LABELS = {
    SCHEDULED: "Ожидает",
    ACTIVE: "Действует",
    EXPIRED: "Истекла",
    BLOCKED: "Заблокирована",
};
export const CORP_LINK_STATE_COLORS = {
    SCHEDULED: "blue",
    ACTIVE: "green",
    EXPIRED: "default",
    BLOCKED: "red",
};
export const zLinkEndedReason = z.enum(["MANUAL", "CLIENT_DELETED", "COMPANY_ARCHIVED"]);
export const LINK_ENDED_REASON_LABELS = {
    MANUAL: "отвязан вручную",
    CLIENT_DELETED: "аккаунт клиента удалён",
    COMPANY_ARCHIVED: "компания в архиве",
};
export const zBlockedByKind = z.enum(["STAFF", "CORP_ADMIN"]);
export const BLOCKED_BY_KIND_LABELS = {
    STAFF: "оператор",
    CORP_ADMIN: "компания",
};
export const zLinkCreatedByKind = z.enum(["STAFF", "CORP_ADMIN", "SYSTEM"]);
export const zCompanyFilters = z.object({
    search: z.string().optional(),
    status: z.string().optional(),
});
